import React from 'react'
import { Container, Card, CardContent, Typography, Button, Box, Stack, CardMedia } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { useSelector } from 'react-redux'
import { RootState } from 'src/store'
import { useNavigate } from 'react-router-dom'
import { getUserDisplayName } from 'src/features/authSlice'
import { useTranslation } from 'react-i18next'

interface MainContentProps {
  setAllTasksCompleted: (value: boolean) => void
}

const MainContent: React.FC<MainContentProps> = ({ setAllTasksCompleted }) => {
  const { t } = useTranslation()
  const { user } = useSelector((state: RootState) => state.auth)
  const navigate = useNavigate()

  return (
    <Container
      maxWidth="md"
      sx={{ py: 6 }}>
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography
          variant="h4"
          gutterBottom>
          {t('onboarding.greeting', { name: getUserDisplayName(user) })}
        </Typography>
        <Typography
          variant="h6"
          color="textSecondary">
          {t('onboarding.intro')}
        </Typography>
      </Box>

      <Stack
        spacing={2}
        alignItems="center">
        <Card sx={SxProps.card}>
          <CardMedia
            component="img"
            sx={{ width: 200 }}
            image="/images/company-profile.jpg"
            alt={t('onboarding.companyProfile.title')}
          />
          <CardContent sx={{ gap: '10px' }}>
            <Typography color="textSecondary">{t('onboarding.companyProfile.description')}</Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => navigate('/settings?tab=company')}
              fullWidth
              sx={{ mt: 2 }}>
              {t('onboarding.companyProfile.button')}
            </Button>
          </CardContent>
        </Card>

        <Card sx={SxProps.card}>
          <CardMedia
            component="img"
            sx={{ width: 200 }}
            image="/images/company-culture.jpg"
            alt={t('onboarding.cultureSurvey.title')}
          />
          <CardContent>
            <Typography
              color="textSecondary"
              fontSize="15px">
              {t('onboarding.cultureSurvey.description')}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => window.open('#/survey', '_blank')}
              fullWidth
              sx={{ mt: 2 }}>
              {t('onboarding.cultureSurvey.button')}
            </Button>
          </CardContent>
        </Card>

        <Card sx={SxProps.card}>
          <CardMedia
            component="img"
            sx={{ width: 180 }}
            image="/images/department.jpg"
            alt={t('onboarding.department.title')}
          />
          <CardContent sx={{ gap: '10px' }}>
            <Typography color="textSecondary">{t('onboarding.department.description')}</Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => navigate('/department?create-department=true')}
              fullWidth
              sx={{ mt: 2 }}>
              {t('onboarding.department.button')}
            </Button>
          </CardContent>
        </Card>

        <Card sx={SxProps.card}>
          <CardMedia
            component="img"
            sx={{ width: 200 }}
            image="/images/position.jpg"
            alt={t('onboarding.position.title')}
          />
          <CardContent>
            <Typography color="textSecondary">{t('onboarding.position.description')}</Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => navigate('/positions?create-position=true')}
              fullWidth
              sx={{ mt: 2 }}>
              {t('onboarding.position.button')}
            </Button>
          </CardContent>
        </Card>

        {/* <Card sx={SxProps.card}>
          <CardMedia
            component="img"
            sx={{ width: 200 }}
            image="/images/team-member.jpg"
            alt="Live from space album cover"
          />
          <CardContent sx={{ gap: "10px" }}>
            <Typography color="textSecondary">
              Invite a team member to streamline your processes and enhance
              collaboration
            </Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => navigate("/admin")}
              fullWidth
              sx={{ mt: 2 }}
            >
              Invite a Team Member
            </Button>
          </CardContent>
        </Card> */}
      </Stack>
    </Container>
  )
}

const SxProps = {
  card: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexDirection: { xs: 'column', lg: 'row' },
    minWidth: 275,
    py: 1,
    px: 2,
    textAlign: 'center',
    bgcolor: 'background.paper',
    width: '80%',
    '.MuiCardContent-root': {
      width: ['100', '60%'],
      button: {
        textTransform: 'capitalize',
        fontWeight: 'bold'
      }
    }
  }
}
export default MainContent
